/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 */
import * as t from 'io-ts';
export const schemaId = 'SmartSlots';
export const ArticleType = t.union([
    t.literal('author-post'),
    t.literal('category-post'),
    t.literal('page'),
    t.literal('post'),
    t.literal('post_tag-post'),
], 'ArticleType');
export const BreakPoints = t.array(t.union([t.literal('A'), t.literal('B'), t.literal('C'), t.literal('D')], 'schema.items'));
export const BaseConfig = t.intersection([
    t.type({
        id: t.string,
        injectOn: BreakPoints,
        isActive: t.boolean,
        maxInjections: t.number,
        visibleOn: BreakPoints,
    }),
    t.partial({
        classNames: t.string,
    }),
], 'BaseConfig');
export const MinimumCharacters = t.type({
    A: t.number,
    B: t.number,
    C: t.number,
    D: t.number,
}, 'MinimumCharacters');
export const ContentSize = t.union([t.literal('short'), t.literal('medium'), t.literal('long'), t.literal('x-long')], 'ContentSize');
export const Density = t.partial({
    minimumFinalCharacters: MinimumCharacters,
    minimumInitialCharacters: MinimumCharacters,
    minimumSubsequentCharacters: MinimumCharacters,
}, 'Density');
export const defaultDensity = {
    minimumSubsequentCharacters: { A: 1500, B: 1300, C: 1300, D: 1300 },
    minimumInitialCharacters: { A: 500, B: 1200, C: 1200, D: 1200 },
    minimumFinalCharacters: { A: 0, B: 800, C: 800, D: 800 },
};
export const Item = t.partial({
    article_type_slug: t.string,
    type: ArticleType,
}, 'Item');
export const StringList = t.array(t.string);
export const SpotConfig = t.intersection([
    t.type({
        html: t.string,
    }, 'SpotConfig'),
    BaseConfig,
]);
export const RegExp = t.type({
    dotAll: t.boolean,
    flags: t.string,
    global: t.boolean,
    ignoreCase: t.boolean,
    lastIndex: t.number,
    multiline: t.boolean,
    source: t.string,
    sticky: t.boolean,
    unicode: t.boolean,
}, 'RegExp');
export const FallbackVideoConfig = t.intersection([
    t.intersection([
        t.type({
            playerId: t.string,
            type: t.union([t.literal('exCo'), t.literal('jwPlayer')], 'type'),
        }),
        t.partial({
            videoRegex: RegExp,
        }),
    ], 'FallbackVideoConfig'),
    BaseConfig,
]);
export const InContentAdConfig = t.intersection([
    t.type({
        injectOn: t.intersection([t.array(t.string), BreakPoints]),
        visibleOn: t.intersection([t.array(t.string), BreakPoints]),
    }, 'InContentAdConfig'),
    BaseConfig,
]);
export const NewslettersConfig = t.intersection([
    t.type({
        id: t.string,
        isActive: t.boolean,
        newsletterIds: StringList,
    }),
    t.partial({
        injectOn: BreakPoints,
        maxInjections: t.number,
        visibleOn: BreakPoints,
        classNames: t.string,
    }),
], 'NewslettersConfig');
export const SellwildConfig = t.intersection([
    t.type({
        src: t.string,
    }, 'SellwildConfig'),
    BaseConfig,
]);
export const SlotType = t.union([t.literal('incontent'), t.literal('standalone')], 'SlotType');
export const KeystoneWidget = t.intersection([
    t.type({
        widgetType: t.literal('Keystone', 'widgetType'),
        config: BaseConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'KeystoneWidget');
export const SpotWidget = t.intersection([
    t.type({
        widgetType: t.literal('Spot', 'widgetType'),
        config: SpotConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'SpotWidget');
export const FallbackVideoWidget = t.intersection([
    t.type({
        widgetType: t.literal('FallbackVideo', 'widgetType'),
        config: FallbackVideoConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'FallbackVideoWidget');
export const InContentAdWidget = t.intersection([
    t.type({
        widgetType: t.literal('InContentAd', 'widgetType'),
        config: InContentAdConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'InContentAdWidget');
export const NewslettersWidget = t.intersection([
    t.type({
        widgetType: t.literal('Newsletters', 'widgetType'),
        config: NewslettersConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'NewslettersWidget');
export const SellwildWidget = t.intersection([
    t.type({
        widgetType: t.literal('Sellwild', 'widgetType'),
        config: SellwildConfig,
    }),
    t.partial({
        slotType: SlotType,
    }),
], 'SellwildWidget');
export const WidgetType = t.union([
    t.literal('FallbackVideo'),
    t.literal('InContentAd'),
    t.literal('Keystone'),
    t.literal('Newsletters'),
    t.literal('Sellwild'),
    t.literal('Spot'),
], 'WidgetType');
export const SlotSettings = t.type({
    widgets: StringList,
}, 'SlotSettings');
export const SmartSlots = t.intersection([
    t.type({
        densities: t.partial({
            short: Density,
            medium: Density,
            long: Density,
            'x-long': Density,
        }, 'densities'),
        ruleSets: t.array(t.intersection([
            t.type({
                variant: t.string,
                where: t.array(t.type({
                    and: t.array(t.partial({
                        density: ContentSize,
                        href_matches: t.union([t.string, RegExp], 'href_matches'),
                        index_is: t.number,
                        item: Item,
                        next_to: StringList,
                        not: t.partial({
                            href_matches: t.union([t.string, RegExp], 'href_matches'),
                            item: Item,
                            next_to: StringList,
                            within: StringList,
                        }, 'not'),
                    }, 'schema.items')),
                }, 'schema.items')),
                widgetType: WidgetType,
            }),
            t.partial({
                slotType: SlotType,
            }),
        ], 'schema.items')),
        settings: t.intersection([
            t.type({
                contentSizes: t.type({
                    long: t.number,
                    medium: t.number,
                    short: t.number,
                    'x-long': t.number,
                }, 'contentSizes'),
            }),
            t.partial({
                eligibleForFinalSlot: t.boolean,
                maxInjections: t.number,
            }),
        ], 'settings'),
        widgets: t.record(t.string, t.union([
            KeystoneWidget,
            FallbackVideoWidget,
            InContentAdWidget,
            NewslettersWidget,
            SpotWidget,
            SellwildWidget,
        ], 'widgets')),
    }),
    t.partial({
        slots: t.record(t.string, SlotSettings),
    }),
], 'SmartSlots');
export default SmartSlots;
// Success
//# sourceMappingURL=SmartSlots.js.map